/**
 * 供应商
 */

import React from 'react';
import { getData } from '@util';
import { Select, Spin } from 'antd';
import { Debounce, Bind } from 'lodash-decorators';
import { SearchOutlined } from '@ant-design/icons';
import _ from 'lodash';
import {
  GETMANUFACTURERLIST, // 厂家列表模糊查询
  GETLATESTFACTORYNAMEV2, // 查询商品最新厂家名称
} from '@api';

const { Option } = Select;

class FactoryName extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: [],
    };
  }

  componentDidMount() {
    const { productCode, initfactoryName } = this.props;
    if (productCode) {
      this.setState({
        loading: true,
      });
      getData({
        api: GETLATESTFACTORYNAMEV2,
        searchParams: {
          productCode,
        },
      })
        .then(res => {
          if (res.code === 200000) {
            const { factoryName } = res.data;

            if (_.size(res.data) > 0 && factoryName) {
              initfactoryName && initfactoryName(res.data);
              this.setState({
                data: [res.data],
              });
            }
          }
        })
        .catch(err => {
          this.setState({
            loading: false,
          });
        });
    }
  }

  @Bind()
  @Debounce(1000)
  getSupplierCodeData(val) {
    if (!val) return false;
    this.setState({
      loading: true,
    });
    getData({
      api: GETMANUFACTURERLIST,
      searchParams: {
        factoryName: val,
      },
    })
      .then(res => {
        const { result } = res;
        result.forEach(item => {
          // eslint-disable-next-line no-param-reassign
          item.factoryCode = item.factoryName || '';
        });
        this.setState({
          loading: false,
          data: [...result],
        });
      })
      .catch(err => {
        this.setState({
          loading: false,
        });
      });
  }

  render() {
    const { data, loading } = this.state;
    const { valueHasName, labelNoCode, isSingleSelect, renderValue, defaultValue, ...others } =
      this.props;
    let renderList = [...data];
    if (Array.isArray(defaultValue)) {
      renderList = [...renderList, ...defaultValue];
    }
    console.log('999999999=');

    return (
      <Select
        {...others}
        placeholder={'请输入关键词'}
        tokenSeparators={[' ']}
        allowClear
        showArrow
        mode={!isSingleSelect && 'multiple'}
        notFoundContent={loading ? <Spin size="small" /> : null}
        filterOption={false}
        maxTagCount="responsive"
        showSearch
        suffixIcon={<SearchOutlined />}
        onSearch={this.getSupplierCodeData}
        className="multiple-select-and-search"
        onChange={x => {
          if (!isSingleSelect) {
            const y = Array.from(new Set(x));
            console.log('y2222==', y);

            this.props.onChange && this.props.onChange(y, renderList);
          } else {
            const SelectEdRow = renderList.find(item => item.factoryName === x);

            const { manufactureCertWhole, manufactureNotWholeName } = SelectEdRow || {};

            this.props.onChange &&
              this.props.onChange({
                factoryName: x,
                manufactureCertWhole,
                manufactureNotWholeName,
              });
          }
        }}>
        {[...renderList].map(item => (
          <Option
            key={item.factoryName}
            title={`${item.factoryName}`}
            value={renderValue ? renderValue(item) : `${item.factoryName}`}>
            {item.factoryName}
          </Option>
        ))}
      </Select>
    );
  }
}
export default FactoryName;
